import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/alertOrgMembers';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

const unwrap = (res) => res.data?.data ?? res.data;

// Sequential two-request flow: resolve the caller's organization first,
// then pull its member list. Lives wholly in this saga.
function* operation() {
  try {
    const headers = getLocalUser();
    const mineRes = yield call(
      axios.get,
      `${config.API_URL}/organization/mine`,
      { headers },
    );
    const mine = unwrap(mineRes);
    const org = (mine.organizations || [])[0]?.organization;
    if (!org?.uid) {
      yield put(fetchSuccess({ members: [] }));
      return;
    }
    const membersRes = yield call(
      axios.get,
      `${config.API_URL}/organization/${org.uid}/members`,
      { headers },
    );
    const members = unwrap(membersRes);
    yield put(fetchSuccess({ members: members.members || [] }));
  } catch (error) {
    // Individual plan / no org — recipients stay self-only; silently
    // matching the previous best-effort behavior (no global error).
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
